import styled from "styled-components";

import { COLORS } from "@treelab/panda";

export const Container = styled.div`
  & svg {
    color: ${COLORS.yellow};
  }

  & input + div {
    z-index: 0;
  }
`;
